import { useEffect, useState } from 'react';

// Piccolo hook per stato persistente in localStorage (fallback sicuro se il parse fallisce).
export function useLocalStorageState(key, initialValue) {
  const [state, setState] = useState(() => {
    try {
      const raw = window.localStorage.getItem(key);
      return raw != null ? JSON.parse(raw) : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(state));
    } catch {
      // ignora errori di scrittura (es. storage pieno / modalità privata)
    }
  }, [key, state]);

  return [state, setState];
}
